/* eslint-disable */

/** unique or primary key constraints on table "argo.calendar_location" */
export enum ArgoCalendarLocationConstraint {
  /** unique or primary key constraint on columns "calendar_location_id" */
  CalendarLocationPkey = 'calendar_location_pkey'
}

/** select columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationSelectColumn {
  /** column name */
  ActiveRange = 'active_range',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_calendar_location_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationSelectColumnArgoCalendarLocationAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_calendar_location_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationSelectColumnArgoCalendarLocationAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.calendar_location" */
export enum ArgoCalendarLocationUpdateColumn {
  /** column name */
  ActiveRange = 'active_range',
  /** column name */
  CalendarId = 'calendar_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

